import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import {
    Pc24CreditImportsTableDefinitionZod,
    pc24FailedRowSchema,
    pc24InFlightRowSchema,
    pc24SucceededRowSchema,
} from '../tables';

type Arguments = {
    loanRequestId: string;
    position?: number;
};

const summaryFields = {
    loanRequestId: true,
    status: true,
    succeededAt: true,
} as const;

export const schemaPc24CreditImportStatusSummary = z.discriminatedUnion('status', [
    pc24InFlightRowSchema.pick(summaryFields),
    pc24SucceededRowSchema.pick(summaryFields),
    pc24FailedRowSchema.pick(summaryFields),
]);

export const schemaLoanRequestResolver_GetPc24CreditImportStatus = z
    .union([Pc24CreditImportsTableDefinitionZod, schemaPc24CreditImportStatusSummary])
    .nullable();

export type SchemaLoanRequestResolver_GetPc24CreditImportStatus = z.infer<
    typeof schemaLoanRequestResolver_GetPc24CreditImportStatus
>;

export type LoanRequestResolver_GetPc24CreditImportStatus = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetPc24CreditImportStatus
>;
